import { useState } from 'react';
import { getCategoryNotif } from '@services/api/notification';
import { errorLogger } from '@ajaibid/utils';

const useNotification = () => {
  const [notifCategory, setNotifCategoru] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchNotifCategory = async () => {
    setIsLoading(true);
    try {
      const response = await getCategoryNotif();
      setNotifCategoru(response.results);
    } catch (err) {
      errorLogger('ERROR_API', err.message, { function: 'fetchNotifCategory' });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    notifCategory,
    fetchNotifCategory,
  };
};

export default useNotification;
